import React from 'react';
import {
    Box,
} from '@saladbob/sassafras'

import getSite from '../../crud/getSite';
import getBlog from '../../crud/getBlog';
import getPosts from '../../crud/getPosts';
import { useEnv } from '../../components/providers/EnvProvider';
import Blocks from '../../components/blocks/Blocks';
import News from '../../components/news/News';
import Layout from '../../components/Layout';
import type { NextPageWithLayout, PageProps } from '../_app';
import Post from '../../types/Post';
import Notice from '../../types/Notice';

type Props = {
    posts: Post[],
    page: number,
    totalPages: number,
    Header: React.FC,
    notices: Notice[],
    blog: {
        layout: Array<any>,
    }
};

export async function getStaticProps() {
    const site = await getSite();
    const blog = await getBlog(process.env.NEXT_PUBLIC_API_URL);

    const notIn = blog.page && blog.page.layout.length > 0 && blog.page.layout.reduce((acc, block) => {
        if (block.blockType === 'postslider') {
            return [...acc, ...block.posts.map((post) => post.id)];
        }
        return acc;
    }, []);

    const { errors, posts } = await getPosts(process.env.NEXT_PUBLIC_API_URL, { limit: Number(blog.postsPerPage), notIn });

    if (errors && errors.length > 0) {
        return {
            props: {
                postsPerPage: blog.postsPerPage,
                posts: [],
                page: [],
                notices: [],
                totalPages: 0,
                ...site,
                blog: blog.page,
            },
        };
    }

    return {
        props: {
            postsPerPage: blog.postsPerPage,
            posts: posts.docs,
            page: posts.page,
            notices: [],
            totalPages: posts.totalPages,
            ...site,
            blog: blog.page,
        },
    }
}



const Page: NextPageWithLayout<Props> = ({ posts, page, blog, notices, totalPages }) => {
    const { postIds } = useEnv();
    return (
        <Box>
            {blog && (<Blocks blocks={blog.layout} />)}
            <News posts={posts} notices={notices} page={page} totalPages={totalPages} notIn={ postIds } />
        </Box>
    );
};

Page.getLayout = function getLayout(page: React.ReactElement, pageProps: PageProps ) {
    return (
        <Layout { ...pageProps }>
            {page}
        </Layout>
    )
}

export default Page;